import * as React from 'react';
import { ILayoutProps } from './ILayout';
import Header from './Header/Header';
import { Container } from '@mui/material';
import './Layout.scss';

const Layout = (props: ILayoutProps) => {
    return (
        <>
            <Header />
            <Container disableGutters={location.pathname === '/project-info' || location.pathname === '/project-type' ? false : true} maxWidth={location.pathname === '/project-info' || location.pathname === '/project-type' ? 'md' : false}>
            <main>{props.children}</main>
            </Container>
        </>
    );
};
export default Layout;
